
import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white/95 backdrop-blur-xl border-t border-gray-200/50 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/c0d1285fec052420b550c183fa81f8a4.png" 
                alt="Ligare AI" 
                className="h-24 w-auto"
              />
            </div>
            <p className="text-gray-600 text-lg leading-relaxed max-w-md">
              Deploy autonomous A.I. systems that automate your lead generation, 
              client management, and operations — customized for your industry.
            </p>
          </div>
          <div>
            <h6 className="text-xl font-semibold mb-6 text-gray-900">Services</h6>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Lead Generation A.I.
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Process Automation A.I.
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Client Experience A.I.
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h6 className="text-xl font-semibold mb-6 text-gray-900">Industries</h6>
            <ul className="space-y-3">
              <li>
                <a href="#industries" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Health & Wellness
                </a>
              </li>
              <li>
                <a href="#industries" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Home Services
                </a>
              </li>
              <li>
                <a href="#industries" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Finance
                </a>
              </li>
              <li>
                <a href="#industries" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Professional Services
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-200/50 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-600 text-sm">
              © 2024 Ligare A.I. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
